<template>
<div>
  <p class="c7">
    <span class="c15 c17">STATMUSE TERMS OF SERVICE</span>
  </p>
  <p class="c7">
    <span class="c15 c22 c20 c24">Last updated April 24, 2017</span>
  </p>
  <p class="c7 c8">
    <span class="c11"></span>
  </p>
  <p class="c7 c8">
    <span class="c11"></span>
  </p>
  <p class="c1">
    <span class="c4">WELCOME TO STATMUSE!</span>
  </p>
  <p class="c1">
    <span class="c4 c15">PLEASE READ THESE TERMS OF SERVICE (THE &quot;TERMS&quot;) CAREFULLY. BY ACCESSING ANY PAGE OF THE STATMUSE WEBSITE,
      MOBILE APPLICATION, OR AUDIO APPLICATION (TOGETHER, THE &quot;SITE&quot;) OR USING ANY STATMUSE SERVICE (COLLECTIVELY
      WITH THE SITE, THE &quot;SERVICE&quot;), YOU AGREE TO BE BOUND BY THESE TERMS AND ALL OTHER PROVISIONS INCORPORATED
      BY REFERENCE.</span>
  </p>
  <p class="c1">
    <span class="c4 c15">IF YOU RESIDE IN THE UNITED STATES, PLEASE NOTE: SECTION 6.9 OF THESE TERMS OF SERVICE CONTAINS AN ARBITRATION CLAUSE
      AND CLASS ACTION WAIVER. IT AFFECTS HOW DISPUTES WITH US ARE RESOLVED. BY ACCEPTING THESE TERMS OF SERVICE, YOU AGREE
      TO BE BOUND BY THIS ARBITRATION PROVISION. PLEASE READ IT CAREFULLY. IF YOU DO NOT WISH TO BE SUBJECT TO ARBITRATION,
      YOU MAY OPT OUT BY FOLLOWING THE INSTRUCTIONS PROVIDED IN THE ARBITRATION PROVISION BELOW.</span>
  </p>
  <p class="c19">
    <span class="c6">1. USING STATMUSE SERVICE</span>
  </p>
  <p class="c1">
    <span class="c4">1.1 Your Personal Use.</span>
    <span class="c5 c20">&nbsp;You may use the StatMuse Service for your personal enjoyment and information. Subject to Your compliance with
      these Terms, StatMuse grants You: (i) a limited, non-assignable, revocable right to access and use the Service for
      Your non-commercial informational and research use, and (ii) a limited, non-exclusive, revocable, non-sublicensable
      license to download and share StatMuse Content as may be made available and expressly allowed and permitted by the
      Service. &quot;</span>
    <span class="c4">StatMuse Content</span>
    <span class="c0">&quot; includes all content, results, data, text, charts, graphics, animation, audio, sounds, music, interactive features,
      messages, commentary, derived insights and other information and content created, licensed, or made available by
      StatMuse. Except as expressly granted above, nothing in these Terms confers any license to any intellectual property
      rights, whether by estoppel, implication or otherwise.</span>
  </p>
  <p class="c1">
    <span class="c0">If you wish to use the Service or StatMuse Content for commercial purposes, please contact StatMuse at support@statmuse.com.</span>
  </p>
  <p class="c1">
    <span class="c4">1.2 Uses That Are Not Allowed.</span>
    <span class="c0">&nbsp;You are not permitted to: </span>
  </p>
  <p class="c2">
    <span class="c0">(i) use the Service or StatMuse Content except as expressly permitted by these Terms; </span>
  </p>
  <p class="c2">
    <span class="c0">(ii) reproduce, duplicate, copy, store, sell, resell, rent, lease, distribute, perform, display, modify or make derivative
      uses of the Service or StatMuse Content, in whole or in part, except as expressly allowed by these Terms; </span>
  </p>
  <p class="c2">
    <span class="c0">(iii) use any manual or automated data mining, scraping, crawling, spiders, robots or similar data gathering or extraction
      methods on any webpage, screen or other content contained in, generated by or relating to the Service; </span>
  </p>
  <p class="c2">
    <span class="c0">(iv) introduce or transmit any worms, viruses, malware or any code of a destructive nature onto or via the Service;
      </span>
  </p>
  <p class="c2">
    <span class="c0">(v) conduct any activity using the Service or StatMuse Content that is illegal or in violation of any applicable laws
      and regulations, including, without limitation, all national, state, local and other laws and regulations relating
      to copyright, privacy, gaming and spamming;</span>
  </p>
  <p class="c2">
    <span class="c0">(vi) systematically retrieve data or other content from the Service to create or compile, directly or indirectly, in
      single or multiple downloads, a collection, compilation, database, directory or the like, whether by manual methods,
      through the use of bots, crawlers, scraping, spiders, or otherwise; &nbsp;</span>
  </p>
  <p class="c2">
    <span class="c0">(vii) access, tamper with, or use non-public areas of the Service, StatMuse&rsquo;s computer systems, or the technical
      delivery systems of the Service or any third-party provider system;</span>
  </p>
  <p class="c2">
    <span class="c0">(viii) &nbsp;attempt to probe, scan, or test the vulnerability or performance of any StatMuse computer system or network
      or breach any security or authentication measures;</span>
  </p>
  <p class="c2">
    <span class="c0">(ix) &nbsp;avoid, bypass, remove, deactivate, impair, descramble, or otherwise circumvent any technological measure
      implemented by StatMuse or any of StatMuse&rsquo;s providers or any other third party (including another user) to
      protect the Service or StatMuse Content;</span>
  </p>
  <p class="c2">
    <span class="c0">(x) &nbsp;attempt to decipher, decompile, disassemble or reverse engineer any of the software used to provide the Service
      or StatMuse Content; or</span>
  </p>
  <p class="c2">
    <span class="c0">(xi) &nbsp;advocate, encourage, or assist any third party in doing any of the foregoing.</span>
  </p>
  <p class="c2 c8">
    <span class="c0"></span>
  </p>
  <p class="c1">
    <span class="c4">1.3. &nbsp;Eligibility; Digital Signature. </span>
    <span class="c5 c20">The Service is intended solely for persons who are (i) 18 or older, or (ii) 13 and older if either (a) an emancipated
      minor, or (b) he/she possess legal parental or guardian consent. All users must be willing and able and competent
      to enter into the terms, conditions, obligations, affirmations, representations, and warranties set forth in these
      Terms, and to abide by and comply with these Terms. In any case, you affirm that you are over the age of 13, as the
      Service is not intended for children under 13. &nbsp;If you are under 13 years of age, then please do not use the
      Service.</span>
  </p>
  <p class="c1">
    <span class="c0">By registering for a User Account, or by clicking to accept these Terms, you are deemed to have executed these Terms
      electronically, effective on the date you register your Account, pursuant to the U.S. Electronic Signatures in Global
      and National Commerce Act (the E-Sign Act) (15 U.S.C. &sect; 7001, et seq.). Your creating of a User Account constitutes
      an acknowledgement that you are able to electronically receive, download, and print these Terms, and any amendments.</span>
  </p>
  <p class="c1">
    <span class="c4">1.4 Your Account.</span>
    <span class="c5 c20">&nbsp;You must be a real person to consent to these Terms. Accounts registered by &quot;bots&quot; or other automated
      methods are not permitted. You must provide a valid email address and other information requested in order to complete
      the registration process. If the username You selected is that of a brand or publicly known name and likeness, and
      You do not have permission to operate under this username or if using this username may mislead or confuse others
      with regard to its brand, likeness or business affiliation, StatMuse may, at its discretion, revoke that username
      and may award it to the brand or publicly known name and likeness in question. If You provide personal identifiable
      information, such information is collected and managed under StatMuse&#39;s&nbsp;</span>
    <span class="c5 c23">
      <a class="c25" href="https://www.statmuse.com/privacy">Privacy Policy</a>
    </span>
    <span class="c0">. You are responsible for maintaining the security of Your account and password.</span>
  </p>
  <p class="c1">
    <span class="c4">1.5. Your Content.</span>
    <span class="c0">&nbsp;The Service allows You to input search queries and questions, submit comments and headlines, and post other content
      (&quot;Your Content&quot;). You may not submit or post any content that: (i) is threatening, libelous, defamatory,
      or obscene; (ii) would constitute, or that encourages conduct that would constitute, a criminal offense, give rise
      to civil liability, or otherwise violate law; (iii) infringes the intellectual property, privacy, or other rights
      of any other person or entity; (iv) contains a computer virus or other destructive element; (v) contains advertising;
      or (vi) constitutes or contains false or misleading statements. StatMuse in its sole discretion may refuse to post
      and remove any of Your Content from the Site, in whole or in part, for any reason.</span>
  </p>
  <p class="c1">
    <span class="c4">1.6. Changes to Service and Terms.</span>
    <span class="c0">&nbsp;StatMuse may at any time to modify, enhance or discontinue, temporarily or permanently, the Service (or any part
      thereof). Your use of any new Service features and resources are subject to these Terms. StatMuse reserves the right
      to change or modify these Terms from time to time. Any change or modification will be effective upon posting on this
      Site. You are advised to review these Terms periodically to ensure compliance with the most recent terms. Your continued
      use of the Service following the posting of any change or modification of the Terms will constitute Your acceptance
      of such change or modification. If You do not agree to any modified or revised Terms, You must stop accessing and
      using the Service.</span>
  </p>
  <p class="c1">
    <span class="c4">1.7. Indemnity.</span>
    <span class="c0">&nbsp;You will indemnify, defend and hold StatMuse harmless from and against any claim, demand, suit or proceeding
      made or brought against StatMuse by a third party arising out of (i) Your use of the Service or StatMuse Content
      in violation of these Terms, and (ii) any claim that Your unauthorized use of the Service or StatMuse Content, or
      any of Your Content, infringes or misappropriates the intellectual property or proprietary rights of a third party
      or violates any law, rule or regulation. You will indemnify StatMuse from and against any related damages, losses,
      liabilities, expenses, attorney fees and costs.</span>
  </p>
  <p class="c19">
    <span class="c6">2. THIRD PARTY CONTENT AND APPS</span>
  </p>
  <p class="c1">
    <span class="c4">2.1. Third Party Content.</span>
    <span class="c5 c20">&nbsp;You understand that the Service gathers, organizes and presents </span>
    <span class="c21">&nbsp;</span>
    <span class="c5 c20">content, results, data, text,</span>
    <span class="c21">&nbsp;</span>
    <span class="c0">charts, graphics, animation, audio, sounds, music, interactive features, messages, commentary, derived insights and
      other information based on available information and data provided by third parties or contributed by Service users
      (together, &quot;Third Party Content&quot;). StatMuse may not pre-screen Third Party Content presented or available
      through the Service. StatMuse has the right in its sole discretion to limit, restrict or remove any Third Party Content
      from the Service. StatMuse makes no claim or representation regarding, and accepts no responsibility for, the quality,
      content, nature or reliability of any Third Party Content. StatMuse does not represent or warrant the accuracy of
      any Third Party Content, undertakes no responsibility to update or review any Third Party Content, and makes no guarantee
      as to the accuracy, timeliness or completeness of any Third Party Content. Providing Third Party Content or attribution
      to the source of any Third Party Content does not imply affiliation, endorsement or adoption by StatMuse of the Third
      Party Content or Third Party Content provider. In the event that a Third Party Content provider requires StatMuse
      to remove or discontinue use of any Third Party Content, StatMuse may in turn direct You to cease using such Third
      Party Content and expunge it from the Service (including from Your system, if applicable). You agree to comply promptly
      with any such direction.</span>
  </p>
  <p class="c1" id="h.gjdgxs">
    <span class="c4">2.2. Third Party Apps.</span>
    <span class="c0">&nbsp;Third party applications or services (&quot;Third Party Apps&quot;) may provide you access to the Service or
      be available through or connect with the Service. &nbsp;StatMuse does not warrant, and is not responsible for the
      legality, quality, accuracy, integrity, fitness, reliability, or availability of any such Third Party Apps. &nbsp;Your
      use of such Third Party Apps will be solely between You and such Third Party App provider and subject to the terms
      and conditions of the Third Party App provider. If You install or enable Third Party Apps for use with the Service,
      or to access the Service from the Third Party Apps, You acknowledge and agree that: (i) StatMuse may access and use
      Your data and basic account information from such Third Party Apps as needed to provide the Services and in accordance
      with these Terms; (ii) You are solely responsible for ensuring that You understand and abide by the rights and obligations
      with any Third Party App provider; and (iii) StatMuse will not be responsible for any storage, handling, disclosure,
      modification or deletion of Your data by a Third Party App provider. If You do not want to permit the exchange of
      Your data or account information, or Your Content, with Third Party Apps, do not enable such Third Party Apps for
      use with the Service.</span>
  </p>
  <p class="c1">
    <span class="c4">2.3. Third Party Sites.</span>
    <span class="c0">&nbsp;The Service may provide links to third-party websites (&quot;Third Party Sites&quot;) where You may obtain Third
      Party Content. StatMuse does not monitor or have any control over any Third Party Sites. StatMuse makes no claim
      or representation regarding, and accepts no responsibility for, the quality, content, nature or reliability of any
      Third Party Sites, or Third Party Sites linking to the Service. StatMuse provides links to Third Party Sites to You
      only as a convenience, and the inclusion of any link does not imply affiliation, endorsement or adoption by StatMuse
      of any Third Party Site or any information contained therein. When You leave a StatMuse Site, You understand that
      StatMuse&#39;s Terms and policies no longer govern. You should review the applicable terms and policies, including
      privacy and data gathering practices, of any Third Party Site to which You navigate.</span>
  </p>
  <p class="c1">
    <span class="c4">2.4. Indemnity.</span>
    <span class="c0">&nbsp;You will indemnify, defend and hold StatMuse harmless from and against any claim, demand, suit or proceeding
      made or brought against StatMuse by a third party arising out of (i) Your use of Third Party Content, Third Party
      Apps including data from such Third Party Apps, or Third Party Sites, and (ii) any claim that Your use of Third Party
      Content, Third Party Apps including data from such Third Party Apps, and Third Party Sites, infringes or misappropriates
      the intellectual property or proprietary rights of another party or violates any law, rule or regulation. You will
      indemnify StatMuse from and against any related damages, losses, liabilities, expenses, attorney fees and costs.</span>
  </p>
  <p class="c19">
    <span class="c6">3. INTELLECTUAL PROPERTY</span>
  </p>
  <p class="c1">
    <span class="c4">3.1. StatMuse Content.</span>
    <span class="c0">&nbsp;The Service and StatMuse Content, including, without limitation, any and all logos, designs, text, graphics,
      pictures, animation, information, data, software, algorithms, sound files, other files, any selection and arrangement
      of any of the foregoing and anything else provided by the Service are the proprietary property of StatMuse or its
      licensors and are protected by U.S. and international intellectual property laws. The copyrights of the look and
      feel of the Service and StatMuse Content are the sole and exclusive property of StatMuse. You may not duplicate,
      copy, distribute or reuse any portion of the HTML/CSS code or visual design elements of the Service or StatMuse Content
      without the prior written consent of StatMuse, except as expressly permitted by these Terms. </span>
  </p>
  <p class="c1">
    <span class="c4">3.2. Brand Features.</span>
    <span class="c0">&nbsp;The StatMuse name, logos, slogans, look and feel of the Service (including all page headers, custom graphics,
      button icons and scripts), and other brand features are the trademarks, service marks and/or trade dress of StatMuse
      (collectively, &quot;StatMuse Brand Features&quot;). Without the prior written permission from StatMuse, You may
      not: (i) copy, imitate or use, in whole or in part, any StatMuse Brand Feature; or (ii) use any metatags or any other
      &quot;hidden text&quot; utilizing &quot;StatMuse&quot; or any other name, trademark or product or service name of
      StatMuse. To the extent that You are allowed by the Service to copy, share and embed certain StatMuse Content containing
      StatMuse Brand Features, You are allowed to do so provided You do not remove or obfuscate any such included StatMuse
      Brand Features. All other trademarks, product names and company names or logos mentioned by or appearing in the Service
      are the property of their respective owners, and you agree not to remove, obscure, or modify any notices or attributions
      of such owners. Reference in the Service to any third party products, services, processes or other information, by
      trade name, trademark, manufacturer, supplier or otherwise, does not constitute or imply endorsement, sponsorship
      or recommendation thereof by StatMuse.</span>
  </p>
  <p class="c1">
    <span class="c4">3.3. Your Content.</span>
    <span class="c0">&nbsp;When You upload, summit or send Your Content to or through the Service, directly or via any Third Party App,
      You hereby grant StatMuse a worldwide, perpetual, irrevocable, royalty-free license to use, host, store, reproduce,
      modify, create derivative works, publish, publicly perform, publicly display, repost and distribute Your Content
      in order to provide the Service to You and others, and for all other StatMuse business purposes, including improving
      the Service, sharing Your Content with third parties, and developing new services and products. If You do not want
      to grant StatMuse such a license to Your Content, You should not use the Service to upload, summit or sent Your Content.</span>
  </p>
  <p class="c1">
    <span class="c4">3.4. Copyright Policy.</span>
    <span class="c0">&nbsp;In accordance with the United States Digital Millennium Copyright Act, if You or anyone else (&quot;Notice Giver&quot;)
      accessing or using the Service believes that any material on the Service violates Notice Giver&#39;s intellectual
      property rights, Notice Giver should promptly send a written notice to StatMuse&#39;s Copyright Agent (identified
      below) containing the following information: (i) a physical or electronic signature of the copyright owner or a person
      authorized to act on their behalf; (ii) identification of the copyrighted work claimed to have been infringed; (iii)
      identification of the material that is claimed to be infringing or to be the subject of infringing activity and that
      is to be removed or access to which is to be disabled, and information reasonably sufficient to permit StatMuse to
      locate the material; (iv) the Notice Giver&#39;s contact information, including address, telephone number, and an
      email address; (v) a statement that the Notice Giver has a good faith belief that use of the material in the manner
      complained of is not authorized by the copyright owner, its agent, or the law; and (vi) a statement that the information
      in the notification is accurate, and, under penalty of perjury, that Notice Giver is authorized to act on behalf
      of the copyright owner.</span>
  </p>
  <p class="c1">
    <span class="c0">Counter-Notice. If you believe that Your Content that was removed (or to which access was disabled) is not infringing,
      or that you have the authorization from the copyright owner, the copyright owner&#39;s agent, or pursuant to the
      law, to post and use the material in your Content, you may send a counter-notice containing the following information
      to the Copyright Agent (i) your physical or electronic signature; (ii) identification of the Content that has been
      removed or to which access has been disabled and the location at which the Content appeared before it was removed
      or disabled; (iii) a statement that you have a good faith belief that the Content was removed or disabled as a result
      of mistake or a misidentification of the Content; and (iv) your name, address, telephone number, and e-mail address,
      a statement that you consent to the jurisdiction of the federal court in San Francisco, California, and a statement
      that you will accept service of process from the person who provided notification of the alleged infringement. If
      a counter-notice is received by the Copyright Agent, StatMuse may send a copy of the counter-notice to the original
      complaining party informing that person that it may replace the removed Content or cease disabling it in 10 business
      days. Unless the copyright owner files an action seeking a court order against the Content provider, the removed
      Content may be replaced, or access to it restored, in 10 to 14 business days or more after receipt of the counter-notice,
      at StatMuse&#39;s sole discretion.</span>
  </p>
  <p class="c1">
    <span class="c0">StatMuse Copyright Agent: copyright@statmuse.com</span>
  </p>
  <p class="c19">
    <span class="c6">4. WARRANTIES, DISCLAIMERS AND LIABILITY LIMITATIONS</span>
  </p>
  <p class="c1">
    <span class="c4">4.1. Your Representation.</span>
    <span class="c0">&nbsp;You represent that you are over the age of 18 and have the legal authority to accept and to abide by these Terms.</span>
  </p>
  <p class="c1">
    <span class="c4">4.2. Warranty Disclaimer.</span>
    <span class="c0">&nbsp;IF YOU CHOOSE TO USE THE SERVICES, YOU DO SO AT YOUR SOLE RISK. YOU UNDERSTAND THAT THE SERVICE IS PROVIDED ON
      AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS. &nbsp; STATMUSE EXPRESSLY DISCLAIMS ANY AND ALL WARRANTIES
      OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE. &nbsp;WITHOUT LIMITING THE FOREGOING, STATMUSE EXPLICITLY
      DISCLAIMS ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT, OR NON-INFRINGEMENT,
      AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE. STATMUSE MAKES NO WARRANTY THAT THE SERVICE
      WILL MEET YOUR REQUIREMENTS OR BE AVAILABLE ON AN UNINTERRUPTED, SECURE, OR ERROR-FREE BASIS. STATMUSE MAKES NO WARRANTY
      REGARDING THE QUALITY OF THE SITE. &nbsp;, StatMuse does not represent or warrant that: (i) the Service will meet
      Your specific requirements; (ii) the Service will be uninterrupted, timely, secure, or error-free; (iii) the StatMuse
      Content, Third Party Content, or results that may be obtained from the use of the Service will be accurate, timely
      or reliable; (iv) the quality of any products, services, information, or other material purchased or obtained by
      You through the Service will meet Your expectations; or (v) any errors in the Service will be corrected. StatMuse
      makes no representations or warranties of any kind with respect to any Third Party Content, Third Party Apps or Third
      Party Sites.</span>
  </p>
  <p class="c1">
    <span class="c4">4.3. Limitation of Liability.</span>
    <span class="c0">&nbsp;YOU EXPRESSLY ACKNOWLEDGE AND AGREE THAT, TO THE MAXIMUM EXTENT PERMITTED BY LAW, STATMUSE WILL NOT BE LIABLE
      FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED
      TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA, EMOTIONAL DISTRESS OR OTHER INTANGIBLE LOSSES, ARISING OUT
      OF OR IN CONNECTION WITH THESE TERMS, FROM THE USE OF OR INABILITY TO USE THE SITE OR SERVICES, WHETHER BASED ON
      WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY OR ANY OTHER LEGAL THEORY, AND WHETHER OR NOT
      REVFLUENCE HAS BEEN INFORMED OF THE POSSBILITY OF SUCH DAMAGE, EVEN IF A LIMITED REMEDY SET FORTH HEREIN IS FOUND
      TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, YOU ACKNOWLEDGE AND AGREE
      THAT STATMUSE WILL NOT BE LIABLE FOR YOUR USE OF OR RELIANCE ON ANY CONTENT OR INFORMATION OBTAINED THROUGH THE SERVICES.
      THE ABOVE LIMITATIONS WILL APPLY TO THE EXTENT NOT PROHIBITED BY APPLICABLE LAW. </span>
  </p>
  <p class="c19">
    <span class="c6">5. TERMINATION</span>
  </p>
  <p class="c1">
    <span class="c4">5.1 Termination.</span>
    <span class="c0">&nbsp;StatMuse may terminate Your account and access/use of the Service immediately if You breach any provision of
      these Terms. StatMuse, in its sole discretion, also has the right to suspend or terminate Your account and refuse
      any and all current or future use of the Service, or any other StatMuse service, for any reason at any time. Such
      termination for convenience of the Service will result in the deactivation, deletion or denial of access to Your
      account. StatMuse reserves the right to refuse to provide the Service to anyone for any reason at any time.</span>
  </p>
  <p class="c1">
    <span class="c4">5.2. Effect of Termination.</span>
    <span class="c0">&nbsp;Upon any termination or cancellation of Your account, You will promptly (i) cease using the Service; and (ii)
      cease using and will expunge any StatMuse Content and Third Party Content on Your systems obtained from the Service
      as may be required by StatMuse. Upon request by StatMuse, You will certify in writing that You have complied with
      Section 5.2(ii).
    </span>
  </p>
  <p class="c1">
    <span class="c4">5.3. Survival.</span>
    <span class="c0">&nbsp;The rights and obligations of the parties contained in Sections 1.7, 2.4, 3, 4, 5.2, 5.3 and 6 will survive the
      termination or cancellation of Your account and access to the Service under these Terms.</span>
  </p>
  <p class="c19">
    <span class="c6">6. GENERAL</span>
  </p>
  <p class="c1">
    <span class="c4">6.1. No Assignment.</span>
    <span class="c0">&nbsp;You may not assign any rights and obligations under these Terms, in whole or in part, by operation of law or
      otherwise, without StatMuse&#39;s express prior written consent. Any attempt to do so without such consent will be
      null and of no effect. StatMuse may assign this Agreement provided any assignee fulfills the StatMuse obligations
      set forth in these Terms.</span>
  </p>
  <p class="c1">
    <span class="c4">6.2. Governing Law.</span>
    <span class="c0">&nbsp;You agree that (i) the Service shall be deemed solely based in California, and (ii) the Service shall be deemed
      a passive website that does not give rise to personal jurisdiction over StatMuse, either specific or general, in
      jurisdictions other than California. These Terms shall be governed by the internal substantive laws of the State
      of California, without respect to its conflict of laws principles. You and we agree to submit to the personal jurisdiction
      of a state or federal court located in San Francisco, California for any actions for which the parties retain the
      right to seek injunctive or other equitable relief in a court of competent jurisdiction to prevent the actual or
      threatened infringement, misappropriation or violation of a party&rsquo;s copyrights, trademarks, trade secrets,
      patents, or other intellectual property rights, as set forth in the Dispute Resolution Provision below.</span>
  </p>
  <p class="c1">
    <span class="c0">YOU AND WE AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF OR RELATED TO THE SERVICES OR CONTENT MUST COMMENCE WITHIN
      ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES. OTHERWISE, SUCH CAUSE OF ACTION IS PERMANENTLY BARRED AND WAIVED.</span>
  </p>
  <p class="c1">
    <span class="c4">6.3. Severability, Waiver.</span>
    <span class="c0">&nbsp;If for any reason a court of competent jurisdiction finds any provision of these Terms invalid or unenforceable,
      that provision will be enforced to the maximum extent permissible and the other provisions will remain in full force
      and effect. Except as expressly set forth in these Terms, the exercise by either party of any of its remedies hereunder
      will be without prejudice to its other remedies under these Terms. The failure by either party to enforce any provision
      of these Terms will not constitute a waiver of future enforcement of that or any other provision.</span>
  </p>
  <p class="c1">
    <span class="c4">6.4. Notices.</span>
    <span class="c0">&nbsp;All notices required or permitted under these Terms of Service will be in writing and delivered by courier or
      overnight delivery services, by electronic mail, or by certified mail, and in each instance will be deemed given
      upon receipt. All communications will be sent to the addresses on file related to Your account or to such other address
      as may be specified by either party to the other. Either party may change its address for notices under this agreement
      by giving written notice to the other party.</span>
  </p>
  <p class="c1">
    <span class="c4">6.5. Force Majeure.</span>
    <span class="c0">&nbsp;StatMuse is not be responsible for any failure or delay in its performance under these Terms due to causes beyond
      its reasonable control, including, but not limited to, labor disputes, strikes, lockouts, shortages of or inability
      to obtain labor, energy, raw materials or supplies, war, terrorism, riot, acts of God or governmental action.</span>
  </p>
  <p class="c1">
    <span class="c4">6.6. Export Control.</span>
    <span class="c0">&nbsp;You agree to comply fully with all applicable export laws and regulations of the United States (&quot;Export
      Laws&quot;) to ensure that the Service or any data or information from the Service is: (i) exported or re-exported
      directly or indirectly in violation of Export Laws; or (ii) used for any purposes prohibited by the Export Laws.</span>
  </p>
  <p class="c1">
    <span class="c4">6.7. Relationship.</span>
    <span class="c0">&nbsp;These Terms do not establish any relationship between the parties of partnership, joint venture, employment,
      franchise, or agency. Neither party will have the power to bind the other or incur obligations on the other&#39;s
      behalf without the other&#39;s prior written consent.</span>
  </p>
  <p class="c1">
    <span class="c4">6.8. Entire Agreement.</span>
    <span class="c5 c20">&nbsp;These Terms, together with any other StatMuse terms, conditions and policies, constitute the complete and exclusive
      understanding and agreement between You and StatMuse and supersedes all prior or contemporaneous agreements or understandings,
      written or oral, relating to its subject matter. Any waiver, modification or amendment of any provision of these
      Terms will be effective only if in writing </span>
    <span class="c20 c22">and signed by duly authorized representatives of both </span>
    <span class="c0">parties.</span>
  </p>
  <p class="c7">
    <span class="c9">6.9. &nbsp;Dispute Resolution Provision</span>
  </p>
  <p class="c7">
    <span class="c13 c5">You and StatMuse agree that any dispute, claim or controversy arising out of or relating to these Terms or the breach,
      termination, enforcement, interpretation or validity thereof, or to the use of the Service (collectively &ldquo;Disputes&rdquo;)
      will be resolved according to the provision of this section</span>
  </p>
  <p class="c7 c8">
    <span class="c13 c5"></span>
  </p>
  <p class="c7">
    <span class="c5">(a)</span>
    <span class="c5 c16">&nbsp;Informal Resolution.</span>
    <span class="c5">&nbsp;We will first try to resolve any Dispute informally. Accordingly, neither of us may start a formal proceeding
      (except for Disputes described in Section 10.4 below) for at least 30 days after one of us notifies the other of
      a Dispute in writing. Notice of the Dispute will include a brief written statement that sets forth the name, address,
      and contact information of the party giving it, the facts giving rise to the Dispute, and the relief requested. You
      will send your notice by email to support@statmuse.com </span>
    <span class="c5 c16">AND</span>
    <span class="c13 c5">&nbsp;to 1288 Columbus Avenue, Suite 103, San Francisco, CA 94133. </span>
  </p>
  <p class="c7">
    <span class="c13 c5">&nbsp;</span>
  </p>
  <p class="c7">
    <span class="c5">(b)</span>
    <span class="c5 c16">&nbsp;Formal Resolution.</span>
    <span class="c5">&nbsp; If the Dispute is not resolved informally, we agree that it </span>
    <span class="c9">will be resolved by binding arbitration and not in courts of general jurisdiction</span>
    <span class="c13 c5">; except that each party retains the right to seek injunctive or other equitable relief in a court of competent jurisdiction
      to prevent the actual or threatened infringement, misappropriation or violation of a party&rsquo;s copyrights, trademarks,
      trade secrets, patents, or other intellectual property rights. </span>
  </p>
  <p class="c7">
    <span class="c5">You acknowledge and agree that </span>
    <span class="c9">you and StatMuse are each waiving the right to a trial by jury</span>
    <span class="c13 c5">&nbsp;or to participate as a plaintiff or class member in any purported class action or representative proceeding.
      Further, unless both you and StatMuse otherwise agree in writing, the arbitrator may not consolidate more than one
      person&rsquo;s claims, and may not otherwise preside over any form of any class or representative proceeding. If
      this specific paragraph is held unenforceable, then the entirety of this &ldquo;Dispute Resolution&rdquo; section
      will be deemed void. Except as provided in the preceding sentence, this &ldquo;Dispute Resolution&rdquo; section
      will survive any termination of these Terms.</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(i)</span>
    <span class="c5 c16">&nbsp;Arbitration Rules and Governing Law.</span>
    <span class="c5">&nbsp;The arbitration will be administered by the American Arbitration Association (&ldquo;AAA&rdquo;) in accordance
      with the Commercial Arbitration Rules and the Supplementary Procedures for Consumer Related Disputes (the &ldquo;AAA
      Rules&rdquo;) then in effect, except as modified by this &ldquo;Dispute Resolution&rdquo; section. (The AAA Rules
      are available at&nbsp;</span>
    <span class="c5 c12">www.adr.org/</span>
    <span class="c13 c5">&nbsp;or by calling the AAA at 1-800-778-7879.) The Federal Arbitration Act will govern the interpretation and enforcement
      of this section.</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(ii)</span>
    <span class="c5 c16">&nbsp;Arbitration Process.</span>
    <span class="c5">&nbsp;A party who desires to initiate arbitration must provide the other party with a written Demand for Arbitration
      as specified in the AAA Rules. (The AAA provides a form Demand for Arbitration at&nbsp;</span>
    <span class="c12 c5">www.adr.org/</span>
    <span class="c5">&nbsp;and a separate form for California residents at </span>
    <span class="c12 c5">www.adr.org/</span>
    <span class="c13 c5">.) The arbitrator will be either a retired judge or an attorney licensed to practice law in the state of California
      and will be selected by the parties from the AAA&rsquo;s roster of consumer dispute arbitrators. If the parties are
      unable to agree upon an arbitrator within seven (7) days of delivery of the Demand for Arbitration, then the AAA
      will appoint the arbitrator in accordance with the AAA Rules.</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(iii)</span>
    <span class="c5 c16">&nbsp;Arbitration Location and Procedure.</span>
    <span class="c5 c13">&nbsp;Unless you and StatMuse otherwise agree, the arbitration will be conducted in the county where you reside. If
      your claim does not exceed $10,000, then the arbitration will be conducted solely on the basis of documents you and
      StatMuse submit to the arbitrator, unless you request a hearing or the arbitrator determines that a hearing is necessary.
      If your claim exceeds $10,000, your right to a hearing will be determined by the AAA Rules. Subject to the AAA Rules,
      the arbitrator will have the discretion to direct a reasonable exchange of information by the parties, consistent
      with the expedited nature of the arbitration.</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(iv)</span>
    <span class="c5 c16">&nbsp;Arbitrator&rsquo;s Decision.</span>
    <span class="c13 c5">&nbsp;The arbitrator will render an award within the time frame specified in the AAA Rules. The arbitrator&rsquo;s
      decision will include the essential findings and conclusions upon which the arbitrator based the award. Judgment
      on the arbitration award may be entered in any court having jurisdiction thereof. The arbitrator&rsquo;s award damages
      must be consistent with the terms of the &ldquo;Limitation of Liability&rdquo; section above as to the types and
      the amounts of damages for which a party may be held liable. The arbitrator may award declaratory or injunctive relief
      only in favor of the claimant and only to the extent necessary to provide relief warranted by the claimant&rsquo;s
      individual claim. If you prevail in arbitration, you will be entitled to an award of attorneys&rsquo; fees and expenses,
      to the extent provided under applicable law.</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(v)</span>
    <span class="c5 c16">&nbsp;Fees.</span>
    <span class="c13 c5">&nbsp;Your responsibility to pay any AAA filing, administrative and arbitrator fees will be solely as set forth in
      the AAA Rules. However, if your claim for damages does not exceed $10,000, StatMuse will pay all such fees unless
      the arbitrator finds that either the substance of your claim or the relief sought in your Demand for Arbitration
      was frivolous or was brought for an improper purpose (as measured by the standards set forth in Federal Rule of Civil
      Procedure 11(b)).</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(vi)</span>
    <span class="c5 c16">&nbsp;No Class Action</span>
    <span class="c5">. </span>
    <span class="c9">YOU AND STATMUSE AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN YOUR OR ITS INDIVIDUAL CAPACITY AND NOT
      AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS OR REPRESENTATIVE PROCEEDING.</span>
    <span class="c13 c5">&nbsp;Further, unless both you and we agree otherwise, the arbitrator may not consolidate more than one person&rsquo;s
      claims, and may not otherwise preside over any form of a representative or class proceeding.</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(vii)</span>
    <span class="c5 c16">&nbsp;Changes.</span>
    <span class="c13 c5">&nbsp;Notwithstanding the provisions of the &ldquo;Modification&rdquo; section above, if StatMuse amends this &ldquo;Dispute
      Resolution&rdquo; section after the date you first accepted these Terms (or accepted any subsequent changes to these
      Terms), you will be notified in accordance with these Terms. You may reject any such change by sending us written
      notice (including by email to&nbsp;support@statmuse.com) within 30 days of the date such change became effective,
      as indicated in the &ldquo;Last Updated Date&rdquo; above or in the date of StatMuse&rsquo;s email to you notifying
      you of such change. By rejecting any change, you are agreeing that you will arbitrate any Dispute between you and
      StatMuse in accordance with the provisions of this &ldquo;Dispute Resolution&rdquo; section as of the date you first
      accepted these Terms (or accepted any subsequent changes to these Terms).</span>
  </p>
  <p class="c7 c18">
    <span class="c5">(viii)</span>
    <span class="c5 c16">&nbsp;Enforceability.</span>
    <span class="c13 c5">&nbsp;If the &ldquo;No Class Action&rdquo; section of this Dispute Resolution Provision is found to be unenforceable,
      or if the entire Dispute Resolution Provision is found to be unenforceable, then the entirety of the Dispute Resolution
      Provision will be null and void and, in that case, the parties agree that the exclusive jurisdiction and venue described
      above will govern any action arising out of or related to these Terms.</span>
  </p>
  <p class="c7 c8">
    <span class="c13 c9"></span>
  </p>
  <p class="c7">
    <span class="c13 c9">6.10. &nbsp;International Users</span>
  </p>
  <p class="c7">
    <span class="c13 c5">StatMuse makes no claim that the Services or Content are appropriate for accessing or downloading outside the United
      States. If you access the Services from a location outside the United States, you do so at your own risk and are
      responsible for ensuring that doing so is in full compliance with all applicable laws, rules, regulations or decrees
      of your jurisdiction.</span>
  </p>
  <p class="c7 c8">
    <span class="c13 c9"></span>
  </p>
  <p class="c1">
    <span class="c4 c15">6.11. &nbsp;Notice to California Residents. </span>
  </p>
  <p class="c1">
    <span class="c0">If you are a California resident, under California Civil Code &sect; 1789.3, you may contact the Complaint Assistance
      Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 N.
      Market Blvd., Suite S-202, Sacramento, California 95834, or by telephone at (800) 952-5210 in order to resolve a
      complaint regarding the Service or to receive further information regarding use of the Service.</span>
  </p>
  <p class="c1">
    <span class="c3">Disclaimer: The original, legally binding version of this document is written in English. &nbsp;If it is translated
      into other languages by non-native English-speakers or by software, there may be discrepancies between the English
      version and the translated version. &nbsp;If so, the English version supersedes the translated version.</span>
  </p>
  <p class="c26">
    <span class="c14">&copy; 2017 StatMuse, Inc. All rights reserved.</span>
  </p>
</div>
</template>

<script>
export default {};
</script>

<style scoped>
ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.c2 {
  margin-left: 54pt;
  padding-top: 0pt;
  text-indent: -18pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c6 {
  color: #e8ed91;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 14pt;
  font-style: normal;
}

.c0 {
  color: #e8ed91;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10.5pt;
  font-style: normal;
}

.c11 {
  color: #e8ed91;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-style: normal;
}

.c3 {
  color: #e8ed91;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 10pt;
  font-style: italic;
}

.c26 {
  padding-top: 0pt;
  padding-bottom: 8pt;
  line-height: 1.0791666666666666;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c19 {
  padding-top: 16.9pt;
  padding-bottom: 6pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c7 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c1 {
  padding-top: 0pt;
  padding-bottom: 16.8pt;
  line-height: 1;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c12 {
  -webkit-text-decoration-skip: none;
  color: #0563c1;
  text-decoration: underline;
  text-decoration-skip-ink: none;
}

.c14 {
  font-size: 10pt;
  color: #e8ed91;
  font-weight: 400;
}

.c17 {
  color: #e8ed91;
  font-weight: 700;
  font-size: 16pt;
}

.c13 {
  color: #e8ed91;
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal;
}

.c4 {
  font-size: 10.5pt;
  color: #e8ed91;
  font-weight: 700;
}

.c15 {
  text-decoration: none;
  vertical-align: baseline;
  font-style: normal;
}

.c5 {
  font-size: 10.5pt;
  font-weight: 400;
}

.c9 {
  font-size: 10.5pt;
  font-weight: 700;
}

.c10 {
  background-color: #ffffff;
  max-width: 468pt;
  padding: 72pt 72pt 72pt 72pt;
}

.c25 {
  color: inherit;
  text-decoration: inherit;
}

.c22 {
  font-weight: 400;
}

.c21 {
  color: #e8ed91;
}

.c16 {
  font-style: italic;
}

.c20 {
  color: #e8ed91;
}

.c24 {
  font-size: 11pt;
}

.c23 {
  color: #42a5f5;
}

.c8 {
  height: 11pt;
}

.c18 {
  text-indent: 36pt;
}

.title {
  padding-top: 24pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 36pt;
  padding-bottom: 6pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.subtitle {
  padding-top: 18pt;
  color: #666666;
  font-size: 24pt;
  padding-bottom: 4pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}

li {
  color: #e8ed91;
  font-size: 11pt;
}

p {
  margin: 0;
  color: #e8ed91;
  font-size: 11pt;
}

h1 {
  padding-top: 24pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 24pt;
  padding-bottom: 6pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h2 {
  padding-top: 18pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 18pt;
  padding-bottom: 4pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h3 {
  padding-top: 14pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 14pt;
  padding-bottom: 4pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h4 {
  padding-top: 12pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 12pt;
  padding-bottom: 2pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h5 {
  padding-top: 11pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 11pt;
  padding-bottom: 2pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h6 {
  padding-top: 10pt;
  color: #e8ed91;
  font-weight: 700;
  font-size: 10pt;
  padding-bottom: 2pt;
  line-height: 1.0791666666666666;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Tos.vue